export enum PeriodType {
    Days = 1,
    Months = 2
}